import React from 'react';

import './Footer.scss';
import images from '../../shared/assets/images';
import { sliceLength } from '../../helpers/form';
import { getString } from '../../helpers/styles';

import Search from '../../shared/assets/icons/search.svg';
import Twitter from '../../shared/assets/icons/twitter.svg';
import Facebook from '../../shared/assets/icons/facebook.svg';
import Instagram from '../../shared/assets/icons/instagram.svg';

const { nen, ideal, securePayment } = images;

export default function Footer(props) {
  const { menu, desktopLinks, mobileLinks, user } = props;

  return (
    <footer id="footer">
      <section
        id="footer_form"
        className={getString('footer_form_centered', user.username)}
      >
        {!user.username && (
          <form onSubmit={(e) => search(e)}>
            <label htmlFor="footer_input">
              Zoek een zorgverlener bij jou in de buurt!
            </label>

            <input
              type="number"
              id="footer_input"
              autoComplete="off"
              name="footer_input"
              placeholder="Postcode"
              onChange={(e) => sliceLength(e.target, 4)}
            />

            <span id="footer_input_icon" onClick={(e) => search(e)}>
              <Search />
            </span>
          </form>
        )}

        <div id="footer_social_media">
          <p>Social media</p>
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/ZwangerenPortaal"
              >
                <Facebook />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/zwangerenportal"
              >
                <Twitter />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/zwangerenportaal.nl"
              >
                <Instagram />
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section id="footer_menu" className="footer_desktop">
        <ul id="footer_menu_list">
          {menu.map((column, idx) => (
            <li className="footer_menu_column" key={idx}>
              <a href={column.link}>
                <p>{column.label}</p>
              </a>

              <ul>
                {column.menu.map((item, idx) => (
                  <li key={idx}>
                    <a href={item.link}>{item.label}</a>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </section>

      <section id="footer_standarts">
        <img width="30" height="30" src={nen} alt="nen" />
        <img width="30" height="30" src={ideal} alt="ideal" />
        <img width="30" height="30" src={securePayment} alt="secure-payment" />
      </section>

      <section id="footer_links">
        <ul className="footer_desktop">{links(desktopLinks)}</ul>

        <ul className="footer_mobile">{links(mobileLinks)}</ul>
      </section>

      <section id="footer_rights">
        <div>
          <p>
            Zwangerenportaal B.V, alle rechten voorbehouden
            <span className="footer_mobile">.</span>
          </p>

          <span className="footer_marker">&#8226;</span>
        </div>

        <div>
          <a href="/algemene-voorwaarden">Algemene voorwaarden</a>

          <span className="footer_marker">&#8226;</span>
        </div>

        <div className="footer_desktop">
          <a href="/privacyverklaring">Privacy statement</a>

          <span className="footer_marker">&#8226;</span>
        </div>

        <div className="footer_desktop">
          <a href="/cookieverklaring">Cookie verklaring</a>
        </div>
      </section>
    </footer>
  );

  function search(e) {
    e.preventDefault();

    const value = document.getElementById('footer_input').value.trim();

    if (!value) return;

    location.href = `/organizations?code=${value}`;
  }

  function links(list) {
    return list.map((section, idx) => {
      const items = Object.keys(section.items);

      return (
        <React.Fragment key={idx}>
          {section.title && (
            <li className="footer_section_title">
              {section.title[1] ? (
                <a href={section.title[1]}>{section.title[0]}</a>
              ) : (
                section.title[0]
              )}
            </li>
          )}

          {items.map((item, idx) => (
            <li key={idx}>
              <a href={section.items[item]}>{item}</a>

              {idx !== items.length - 1 && (
                <span className="footer_marker">&#8226;</span>
              )}
            </li>
          ))}
        </React.Fragment>
      );
    });
  }
}
